import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

// helper
import { BaseError } from '../../helpers/BaseError';

// models
import { CompoundTriggerModel } from '../../models/compound-trigger.model';

// API
import API from '../../services/api';

import formulaKeys from './_queryKeys';

export default function useFormulaCompoundTriggerMutation(formulaId?: number) {
    const queryClient = useQueryClient();

    return useMutation<
        AxiosResponse<{ compound_trigger: CompoundTriggerModel }>,
        BaseError,
        { compound_trigger_id?: string }
    >({
        mutationFn: (data: { compound_trigger_id?: string }) =>
            API.updateFormulaCompoundTrigger({ formulaId, data }),

        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: formulaKeys.all });
        },
    });
}
